import { LitElement, html, TemplateResult } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { SsoIntegrationWidgetCard } from '../types';
import { translateFn } from '../../../../utils/translator.helper';
import { ButtonColors, ButtonTypes } from '../../../../ui/gzButton/types';
import { FontSizes, FontWeights } from '../../../../types/common/types';
import { provisionedStatusMap } from '../../../../landingPage/types';

@customElement('gz-sso-integration-widget')
export class SsoIntegrationWidgetWebComponent extends LitElement {
  @property({ type: Array, attribute: true, reflect: true })
  options: SsoIntegrationWidgetCard[] = [];

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html`
      <div class="sso-integration-widget-wrapper">${this.options.map(option => this.renderSsoCard(option))}</div>
    `;
  }

  private renderSsoCard(option: SsoIntegrationWidgetCard): TemplateResult {
    const { id, icon, title, description, url, provisionStatus } = option;

    return html`
      <div class="card--wrapper">
        <div class="card--content ${!description || this.options.length === 3 ? 'no-description-card' : ''}">
          <div class="card--title-wrap">
            <div class="icon">
              <gz-icon name="${icon}" size="24"></gz-icon>
            </div>
            <gz-title
              id="sso-card-${id}-title"
              fontSize="${FontSizes.TITLE}"
              fontWeight="${FontWeights.MEDIUM}"
              class="card--title"
              >${title}</gz-title
            >
          </div>
          ${this.options.length < 3 ? this.renderDescription(description, id) : ''}
          ${this.renderActionButtons(id, url, provisionStatus)}
        </div>
      </div>
    `;
  }

  private renderDescription(description: string, id: string): TemplateResult | undefined {
    if (!description) {
      return;
    }

    return html`
      <gz-text id="sso-card-${id}-description" fontSize=${FontSizes.HEADING_6} class="card--intro"
        >${description}</gz-text
      >
    `;
  }

  private renderActionButtons(id: string, url: string, provisionStatus: number): TemplateResult {
    const isProvisioned = provisionStatus === provisionedStatusMap[id];

    return html`
      <div class="card--action-button-wrapper">
        <gz-button
          id="sso-card-${id}-action-button"
          class="${isProvisioned ? `open-console-${id}` : `go-to-feature-${id}`} card--action-button mr-2"
          @click="${() => this.btnAction(isProvisioned ? `open-console-${id}` : `go-to-feature-${id}`)}"
        >
          ${isProvisioned ? translateFn('Open Console') : translateFn('Go to Feature')}
        </gz-button>
        <gz-button
          id="sso-card-${id}-support-button"
          type="${ButtonTypes.OUTLINE}"
          color="${ButtonColors.SECONDARY}"
          class="card--action-button"
          @click="${() => window.open(url, '_blank')}"
        >
          ${translateFn('Support Center')}
        </gz-button>
      </div>
    `;
  }

  private btnAction(event: string): void {
    this.dispatchEvent(
      new Event(event, {
        bubbles: true,
        composed: true,
      })
    );
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-sso-integration-widget': SsoIntegrationWidgetWebComponent;
  }
}
